import React from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import style from './sec3.module.css'
import "react-circular-progressbar/dist/styles.css";
import GradientSVG from "./gradientSvg";

const Sec3 = () => {
    const [percentage, setPercentage] = useState(0)
    const [flag, setFlag] = useState(false);
    useEffect(() => {
        const obs = setTimeout(() => {
            const observer = new IntersectionObserver((enteries) => {
                const entery = enteries[0]
                if (entery.isIntersecting) {
                    setFlag(true)
                }

            })

            observer.observe(myRef.current)
        }, 1500)



        if (flag)
            if (percentage < 95) {
                setTimeout(() => {
                    setPercentage(percentage + 1)
                }, 40);
            }


    }, [percentage, flag])

    const myRef = useRef()
    const idCSS = "hello";


    return (
        <div ref={myRef} className={`${style.sec3}`}>
            <div className={style.container}>
                <div className={style.box}>
                    <div className={style.child} dir='rtl'>
                        <h3 className={style.h3} style={{ fontWeight: '600' }}>אלפי סטודנטים ומאות השמות</h3>
                        <p className={style.p}>• מחלקת ההשמה שלנו ביחד עם עשרות חברות הייטק שאנו עובדים איתם יעזרו לכם למצוא את המשרה הראשונה שלכם בזמן הכי קצר שיש.</p>

                        <p className={style.p}>• כלל הבוגרים מכל המחזורים שלנו הוכיחו את זה מי שמסיים את הכשרת הDevOps שלנו, עובד!</p>
                    </div>
                    <div className={style.child}>
                        <div className={style.circularProgressbar}>

                            <GradientSVG />


                            <CircularProgressbarWithChildren
                                strokeWidth={8}
                                className={style.circleBg}
                                value={percentage}
                                styles={{
                                    path: { stroke: `url(#${idCSS})`, height: "100%" },
                                    trail: {
                                        stroke: "#151641"
                                    }
                                }}
                            >
                                <strong className={style.circlePercentage} style={{ fontSize: '2em', paddingLeft: '10px', color: 'white' }}>{percentage}%</strong>
                                <p className={style.circleText}>אחוזי השמה</p>

                            </CircularProgressbarWithChildren>

                        </div>


                    </div>
                </div>

            </div>
        </div>
    )
}

export default Sec3